module.exports = __webpack_public_path__ + "res/traffic_go.dd585e08e98ca3e18942a8e04422e22a.webp";